export default {
  priv: 'pr_manage',
  overviewTitle: 'Chauffeurs',
  detailTitle: 'Chauffeur',
  deleteTitle: 'deze chauffeur',
  url: '/manage/drivers',
  apiUrl: '/drivers/',
  sortBy: ['full_name'],
  sortDesc: [false],
  deletable: false,
  editable: true,
  filterName: 'manage/drivers',
  defaultPerPage: 100,
  quickFilter: {
    text: 'Zoek op naam',
    value: 'full_name',
    type: 'text'
  },
  newRecord: {
    is_charter: false,
    country_id: 56,
    is_active: true
  },
  advancedSearchFields: [
    {text: 'Actief', value: 'is_active', type: 'boolean'}
  ],
  // isReadOnlyOverview: true,
  // customEditable(item) {
  //   return false;
  // },
  // customDeletable(item) {
  //   return false;
  // },
  tableFields: [
    {text: 'Naam', value: 'full_name', link: '/manage/drivers/{id}', width: '10%'},
    {text: 'Adres', value: 'street', width: '5%'},
    {text: 'Woonplaats', value: 'city', width: '5%'},
    {text: 'Email', value: 'email', width: '5%'},
    // {text: 'Van', value: 'begin_day', width: '5%'},
    // {text: 'Tot', value: 'end_day', width: '5%'},
    {text: 'Actief', value: 'is_active', type: 'boolean', width: '2%'},
    // {text: 'Geboortedatum', value: 'birth_day', width: '5%'},
    // {text: 'IBAN nr', value: 'bankaccount', width: '10%'},
    // {text: 'RR', value: 'national_nr', width: '10%},
    {text: 'Chauffeur', value: 'is_driver', type: 'boolean', width: '2%'},
    {text: 'Begeleider', value: 'is_pilot', type: 'boolean', width: '2%'},
    {text: 'Planner', value: 'is_coordinator', type: 'boolean', width: '2%'}
  ]
};
